import * as colors from './colors'

export const create = (nodes: array): void => {
  const visibleDictionary: object = {}
  const hiddenDictionary: object = {}
  const reverseHiddenDictionary: object = {}

  nodes.forEach((node, index) => {
    visibleDictionary[node.id] = determineVisibleColors(node)
    const hiddenColor: string = generateHiddenColor(node, index)
    hiddenDictionary[node.id] = hiddenColor
    reverseHiddenDictionary[hiddenColor] = node
  })

  globalThis._CONFIGURATION_.visibleColorsByNodeId = visibleDictionary
  globalThis._CONFIGURATION_.hiddenColorsByNodeId = hiddenDictionary
  globalThis._CONFIGURATION_.nodeIdsByHiddenColor = reverseHiddenDictionary

  createColorCountsDictionary()
  countColors()
}

export const countColors = (): void => {
  if (globalThis._CONFIGURATION_.colorKey === undefined) return
  const colors = Object.values(globalThis._CONFIGURATION_.visibleColorsByNodeId).flat()
  const counts = colors.reduce((obj, color) => {
    obj[color] ??= 0
    obj[color]++
    return obj
  }, {})

  for (const [nodeTypeId, nodes] of Object.entries(globalThis._CONFIGURATION_.colorKey)) {
    for (const [nodeId, node] of Object.entries(nodes)) {
      globalThis._CONFIGURATION_.colorKey[nodeTypeId][nodeId].count = counts[node.color] ?? 0
    }
  }
}

const createColorCountsDictionary = (): void => {
  if (globalThis._CONFIGURATION_.visibleColorsByNodeId === undefined || globalThis._CONFIGURATION_.colorKey === undefined || Object.keys(globalThis._CONFIGURATION_.colorKey).length === 0) return
  const occurrences = {}
  const dictionary = {}

  Object.values(globalThis._CONFIGURATION_.visibleColorsByNodeId).flat().sort((a, b) => a - b).forEach(color => {
    if (occurrences[color] === undefined) {
      occurrences[color] = 1
    } else {
      occurrences[color]++
    }
  })

  for (const [id, color] of Object.entries(Object.assign(...Object.values(globalThis._CONFIGURATION_.colorKey)))) {
    if (occurrences[color] === undefined) continue
    dictionary[id] = {
      color,
      count: occurrences[color]
    }
  }
  globalThis._CONFIGURATION_.countsAndColorsByNodeId = dictionary
}

const determineVisibleColors = (node: object): array => {
  const nodeTypeColor = globalThis._CONFIGURATION_.nodeTypes[node.nodeTypeId].color
  return (nodeTypeColor !== undefined) ? [nodeTypeColor] : determineNeighborColors(node)
}

const determineNeighborColors = (node: object): array => {
  if (globalThis._CONFIGURATION_.colorKey === undefined) return [colors.defaultNode()]
  const colorKey: array = globalThis._CONFIGURATION_.colorKey[node.nodeTypeId]

  if (colorKey === undefined || colorKey === null) return [colors.defaultNode()]
  const adjacentNodeIds: array = matchingNeighborIds(node, colorKey)

  if (adjacentNodeIds.length === 0) return [colors.defaultNode()]
  return adjacentNodeIds.reduce((obj, neighborId) => { obj[neighborId] = colorKey[neighborId].color; return Object.values(obj) }, {})
}

const matchingNeighborIds = (node: object, colorKey: object): array => {
  if (node.adjacentNodeIds === undefined) return []
  return Object.keys(colorKey).filter(neighborId => node.adjacentNodeIds.includes(neighborId))
}

const generateHiddenColor = (node: object, index: number): array => {
  const ret = []
  if (index < 16777215) {
    ret.push(index & 0xff) // R
    ret.push((index & 0xff00) >> 8) // G
    ret.push((index & 0xff0000) >> 16) // B
  }
  return `rgb(${ret.join(', ')})`
}
